import { createLucideIcon } from "lucide-react";

export const Download = createLucideIcon(
    "Download",
    [
        [
            "path",
            {
                d: "M12 14.5C11.2998 14.5 9.9915 12.5057 9.5 12",
                key: "u6yhzf",
            },
        ],
        [
            "path",
            {
                d: "M12 14.5C12.7002 14.5 14.0085 12.5057 14.5 12",
                key: "1i5x5f",
            },
        ],
        [
            "path",
            {
                d: "M12 14.5L12 4.5",
                key: "1j2wj8",
            },
        ],
        [
            "path",
            {
                d: "M20 16.5C20 18.982 19.482 19.5 17 19.5H7C4.518 19.5 4 18.982 4 16.5",
                key: "1w5ipu",
            },
        ],
    ],
);
